<template>
  <el-card shadow="hover" class="my_article_card">
    <!--新建文章--->

    <!--文章卡片--->

    <div class="fileType">
      <div :class="fileType"></div>
      <div class="article_card_btn">
        <template v-if="fileType === 'NEWS'">
          <el-popover placement="right" width="60" trigger="click" v-model="visible">
            <el-button type="text" slot="reference"><i class="el-icon-menu"
                style="font-size: 18px;color: #C6CCD8;"></i></el-button>
            <el-link type="danger" @click="recycleArticle">删除</el-link><br>
            <el-link style="color:#333" @click="exportArticle"> 导出</el-link><br>
            <el-link style="color:#333" @click="moveArticle"> 移动</el-link><br>
          </el-popover>
        </template>
        <template v-if="fileType === 'FOLDER'">
          <el-popover placement="top-start" :width="60" trigger="click" v-model="visible">
            <el-button type="text" slot="reference"><i class="el-icon-menu"
                style="font-size: 18px;color: #C6CCD8;"></i></el-button>
            <el-link @click="toRenameFolder" style="color:#333">重命名</el-link>
            <el-link @click="moveArticle" style="color:#333">移动</el-link>
            <el-link @click="toRecycleArticle" type="danger">删除</el-link>
          </el-popover>
        </template>

      </div>
    </div>
    <el-link :underline="false" @click="editArticle">
      <div class="my_article_card_title">
        <span v-html="title || '未设置标题'"></span>
      </div>
    </el-link>
    <div class="article_card_content">{{ content }}</div>
    <div class="article_card_time">{{ time }}</div>

  </el-card>
</template>

<script>
export default {

  props: ['title', 'content', 'time', 'article_id', 'source', 'keywords', 'fid', 'index', 'fileType'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      visible: false,
      keywordArr: [],
      moveDialogVisible: false,
      chooseForlder: {},
      folders: []
    }
  },
  mounted () {
    if (this.keywords) {
      this.keywordArr = this.keywords.split(',', 3)
    }
  },
  methods: {

    handleNodeClick (data) {
      this.chooseForlder = data
    },
    // 移动文章
    moveArticle () {
      this.$emit('moveArticle', this.article_id, this.index)
    },

    editArticle () {
      this.$emit('editArticle', this.article_id, this.fileType)
    },
    // 删除文章进回收站
    recycleArticle () {
      this.$emit('recycleArticle', this.article_id, this.index)
    },
    // 导出文章
    exportArticle () {
      this.$emit('exportArticle', this.article_id, this.index)
    },
    toRenameFolder () {
      this.$emit('toRenameFolder', this.article_id, this.title)
    },
    toRecycleArticle () {
      this.$emit('toRecycleArticle', this.article_id, this.index)
    }

  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/index.less';

.fileType {
  width: 100%;
  height: 90px;
  padding-top: 33px;
  background-color: #F6F6F8;

  .FOLDER {
    background-image: url("../assets/imgs/folder_title.png");
    width: 65px;
    height: 66px;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: auto;
  }

  .ARTICLE {
    background-image: url("../assets/imgs/article_title.png");
    width: 65px;
    height: 66px;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: auto;
  }

  .NEWS {
    background-image: url("../assets/imgs/article_title.png");
    width: 65px;
    height: 66px;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: auto;
  }
}

.my_article_card {
  width: 260px;
  height: 230px;
  float: left;
  margin: 20px 20px 0 0px;
  /* box-shadow: 0px 0px 8px #666; */
  box-shadow: none;
  position: relative;

  .article_card_content {
    font-size: 0.7em;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-align: left;
    height: 28px;
    margin: 0px;
    margin-bottom: 10px;
    vertical-align: middle;
    color: #bbb;
    padding: 5px 10px;
  }

  .my_article_card_title {
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-align: left;
    vertical-align: middle;
    padding: 0px 10px;
    font-weight: 500;
    padding-bottom: 0px;
    padding-top: 10px;
    height: 20px;
    color: #333;
    word-break: break-all;

  }

}

.el-divider--horizontal {
  margin: 2px 0;
}

.folderContainer {
  height: 15vh;
  overflow-y: auto;
}

.xy_card {
  margin-top: 10px;
}

.keyword_c {
  margin: 2px;
  background-color: #fca63f;
  color: white;
  border-radius: 0px;
}

.article_card_time {
  display: inline-block;
  top: 2px;
  position: relative;
  left: 0px;
  font-size: 0.7em;
  color: #666;
  padding-left: 10px;
}

.article_card_btn {
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 0px;
}

.article_card_btn .el-link {
  font-size: 0.7em !important;
  color: #666;
}

.card_red {
  background: red;
  width: 55px;
  height: 38px;
  font-size: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: -22px;
  top: -13px;
  text-align: center;
  padding-top: 22px;
  color: wheat;
}

.card_blue {
  background: blue;
  width: 55px;
  height: 38px;
  font-size: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: -22px;
  top: -13px;
  text-align: center;
  padding-top: 22px;
  color: wheat;
}

.add_btn {
  text-align: center;
  width: 100%;
}

.add_btn>.el-icon-plus {
  font-size: 80px;
  font-weight: 900;
  color: #ccc;
  text-align: center !important;
}

.add_text {
  text-align: center;
  margin-top: 20px;
  font-size: 0.9em;
}
</style>
<style>
.el-card__body {
  position: relative;
  padding: 0px !important;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/xy_card.vue